import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

const GenericDialog = ({ openDialog, setOpenDialog, title, message, closeText }) => {
  const { t } = useTranslation('common');

  return (
    <Dialog open={openDialog} onClose={() => { setOpenDialog(false); }}>
      <DialogTitle>
        {title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>

        <DialogActions>
          <Button variant="outlined" onClick={() => { setOpenDialog(false); }}>
            {closeText || t('actions.close')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default GenericDialog;
